/** URL of the fetchInstagramReels Cloud Function. Set NEXT_PUBLIC_INSTAGRAM_MEDIA_URL after deploy. */
export const INSTAGRAM_MEDIA_URL =
  import.meta.env.NEXT_PUBLIC_INSTAGRAM_MEDIA_URL ||
  'https://us-central1-elementarycreative-89dae.cloudfunctions.net/fetchInstagramReels'

export const COMMON_NAVLINKS = [
  {
    name: 'Home',
    href: '/',
  },
  {
    name: 'Work',
    href: '/portfolio',
  },
  {
    name: 'Services',
    href: '/services',
  },
  {
    name: 'Blog',
    href: '/blog',
  },
  {
    name: 'Contact',
    href: '/contact',
  },
]
